export default "__VITE_ASSET__764346f2__"